import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { Modal, ModalHeader, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import PowerGenerationMaintenanceForm from '../Forms/PowerGenerationMaintenance';


const AddEditPowerGenerationMaintenanceModal = ({
	dataPowerGenerationMaintenance,
	isOpen,
	isEdit,
	handleToggleModal,
	activeTab,
	toggleTab,
}) => {
	return (
		<Modal
			isOpen={isOpen}
			toggle={handleToggleModal}
			size='xl'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>
			<ModalHeader toggle={handleToggleModal}>
				Registar Mantención
			</ModalHeader>

			<PowerGenerationMaintenanceForm
				dataPowerGenerationMaintenance={dataPowerGenerationMaintenance}
				isOpen={isOpen}
				isEdit={isEdit}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>
		</Modal>
	);
};

export default AddEditPowerGenerationMaintenanceModal;
